import makeStyles from "@mui/styles/makeStyles";
import { View } from "../../Base";

const useStyles = makeStyles({
  container: {
    margin: "20px 0px 0px 20px",
    display: "flex",
    gap: "10px",
  },
});

export const DriverManagementExpiredContent = () => {
  const styles = useStyles();
  return (
    <View className={styles.container}>
      Driver Management user session has expired. Would you like to reload and
      start new session?
    </View>
  );
};
